import * as Dialog from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import type { ReactNode } from 'react'

/**
 * Feuille modale ancrée en bas d'écran (accessible au pouce) : focus piégé, Échap et
 * clic extérieur pour fermer, lecteur d'écran compris (Radix). Remplace les boîtes centrées.
 */
export function Feuille({
  ouverte,
  onChange,
  titre,
  children,
}: {
  ouverte: boolean
  onChange: (ouverte: boolean) => void
  titre: string
  children: ReactNode
}) {
  return (
    <Dialog.Root open={ouverte} onOpenChange={onChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-40 bg-black/40 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
        <Dialog.Content className="fixed inset-x-0 bottom-0 z-50 mx-auto flex max-h-[85dvh] max-w-md flex-col gap-4 overflow-y-auto rounded-t-2xl bg-white p-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-xl data-[state=open]:animate-in data-[state=open]:slide-in-from-bottom data-[state=closed]:animate-out data-[state=closed]:slide-out-to-bottom lg:inset-y-0 lg:my-auto lg:h-fit lg:max-w-lg lg:rounded-2xl lg:data-[state=open]:slide-in-from-bottom-0 lg:data-[state=open]:zoom-in-95 lg:data-[state=closed]:slide-out-to-bottom-0 lg:data-[state=closed]:zoom-out-95">
          <div className="flex items-center justify-between gap-2">
            <Dialog.Title className="text-lg font-bold">{titre}</Dialog.Title>
            <Dialog.Close className="grid size-12 place-items-center rounded-full active:bg-slate-100" aria-label="Fermer">
              <X aria-hidden />
            </Dialog.Close>
          </div>
          <Dialog.Description className="sr-only">{titre}</Dialog.Description>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
